export default __webpack_public_path__ + "static/media/Hair_8_M_C4.23979dad.svg";